import React from 'react';
import { CheckIcon } from 'lucide-react';
import { deliverables, product } from '../data/landing';
export function Deliverables() {
  return <section className="w-full bg-cream py-16 lg:py-24" data-id="element-30" data-mp="10c5y2skfnial">
      <div className="mx-auto max-w-6xl px-6" data-id="element-31" data-mp="1e1zm58o45yj9">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start lg:gap-16" data-id="element-32" data-mp="1e3u88qb4fwox">
          <div className="lg:sticky lg:top-12" data-id="element-33" data-mp="199pzc1iapel7">
            <h2 className="font-serif text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-34" data-mp="1nze1f4yawh9z">
              Esto es todo lo que recibe hoy
            </h2>
            <p className="mt-5 font-sans text-xl leading-relaxed text-inkSoft" data-id="element-35" data-mp="1j2x3jj1auojp">
              Cinco piezas que trabajan juntas: qué comer, cómo moverse y en qué
              orden hacerlo durante su primera semana.
            </p>
            <div className="mt-8 overflow-hidden rounded-2xl bg-teal-soft ring-1 ring-teal/15" data-id="element-36" data-mp="2maw28fkcje8">
              <img src={product.mockup} alt="" className="h-full w-full object-cover" aria-hidden="true" data-id="element-37" data-mp="3uqmzey7fgw6t" />
            </div>
          </div>

          <ul className="space-y-4" data-id="element-38" data-mp="3p3f7i4fcol35">
            {deliverables.map(item => <li key={item.name} className="flex gap-5 rounded-2xl bg-paper p-6 ring-1 ring-teal/10 sm:p-7" data-id="element-39" data-mp="3u3jnzug9dftd">
                <span className="mt-1 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-teal" data-id="element-40" data-mp="2px64hqyc2h1">
                  <CheckIcon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-41" data-mp="7prykpqdl047" />
                </span>
                <div data-id="element-42" data-mp="gpop6wwbs91w">
                  <h3 className="font-serif text-2xl font-semibold text-ink" data-id="element-43" data-mp="gp6if6c1ecfq">
                    {item.name}
                  </h3>
                  <p className="mt-2 font-sans text-lg leading-relaxed text-inkSoft sm:text-xl" data-id="element-44" data-mp="2ifqgkuf1putn">
                    {item.text}
                  </p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}